import { Description as HuiDescription } from '@headlessui/react';
import { FC, ReactNode } from 'react';
import Markdown from 'react-markdown';
import { cx } from '@/utils/cx';

export type DescriptionProps = {
  children: ReactNode;
  className?: string;
};

export const Description: FC<DescriptionProps> = ({ children, className }) => (
  <HuiDescription
    className={cx('min-h-5 text-sm font-normal text-gray-500', className)}
  >
    {/* TODO: Markdown wraps generated code inside a p element. We probably want to handle this differently since that produces nested p elements*/}
    {typeof children === 'string' ? <Markdown>{children}</Markdown> : children}
  </HuiDescription>
);
